'use client'

import type { FC } from 'react'
import PsychologistCard from '@/components/team/psychologistCard'
import { drMeena as leader } from '@/lib/drMeena'
import type { TeamMember } from '@/types/doctor'

interface DrMeenaSectionProps {
  onViewBio: (member: TeamMember) => void
}

const DrMeenaSection: FC<DrMeenaSectionProps> = ({ onViewBio }) => {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 pb-10 sm:pb-12 md:pb-14 lg:pb-16">
        {/* Content */}
        <div className="flex flex-col lg:flex-row items-start justify-between gap-8 sm:gap-10 lg:gap-16">
          {/* Left: Card using the shared PsychologistCard */}
          <div className="w-full lg:w-[640px] shrink-0">
            <PsychologistCard
              member={{
                name: leader.name,
                title: 'Psychiatrist',
                credentials: leader.credentials,
                imageUrl: leader.imageUrl,
                specialty: leader.specialty,
                yearsExperience: leader.yearsExperience,
                expertise: [
                  ...(leader.expertise?.children ?? []),
                  ...(leader.expertise?.adults ?? []),
                ],
              }}
              onViewBio={() => onViewBio(leader)}
              imageHeightClass="h-[28rem] sm:h-[32rem] md:h-[34rem] lg:h-[40rem]"
              imageFit="contain"
              imageBackgroundClassName="bg-white"
            />
          </div>

          {/* Right: Name, degree, and long paragraph */}
          <div className="w-full lg:max-w-[560px] lg:ml-auto lg:pl-6 xl:pl-10">
            <div className="text-center lg:text-right mb-4 sm:mb-5 lg:mb-6 pr-0 lg:pr-1">
              <h2 className="text-[22px] sm:text-[24px] md:text-[28px] font-medium text-black leading-snug">
                Dr Meena Gnanashekharan
              </h2>
              <p className="text-base sm:text-[18px] md:text-[20px] italic text-black/80 mt-0.5">
                MBBS
              </p>
            </div>

            <p className="text-[15px] sm:text-base md:text-[18px] leading-[1.75] sm:leading-7 text-black/85 text-center lg:text-left">
              Dr. Meena is an American Board Certified Psychiatrist, practicing
              Child, Adolescent and Adult Psychiatry. She specializes in the
              treatment of Mood Disorders (Major Depressive disorders and the
              Bipolar Spectrum), and Anxiety Disorders (including phobias, OCD,
              Social Anxiety disorders). She combines her knowledge and
              experience with empathy and applies an integrative model of
              treating the mind, body and spirit for optimal effectiveness. She
              is passionate about Behavioural Health and helping people get
              access to the treatment and care that they need. She places a lot
              of importance on holistic treatments, focusing equally on
              pharmacological interventions, psychotherapy and counselling as
              well as other alternative treatments.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DrMeenaSection
